import React from 'react'
import { Menu, Image } from '../../../components'
import { useNavigation } from '@react-navigation/native'
import { useDispatch, useSelector } from 'react-redux'
import { getAvatarImage } from '../../../tools/dataParse'
import { initSelector } from '../../../redux/initReducer/initSelector'
import loginActions from '../../../redux/login/loginActions'
import { StyleSheet, View } from 'react-native'
import { usePlatforms } from '../../../hooks/usePlatforms'

const UserPhoto = () => {
  const navigation = useNavigation()
  const dispatch = useDispatch()
  const { isTablet } = usePlatforms()
  const { avatar } = useSelector(initSelector)

  const styles = useStyles(isTablet)

  const onGoToPreferredLanes = () => navigation.navigate('preferred-lanes')

  const onGoToProfile = () => navigation.navigate('profile')

  const onLogout = () => {
    dispatch(loginActions.logout(() => navigation.navigate('login')))
  }

  const menuItems = [
    { text: 'Profile', fn: onGoToProfile, testID: 'avatarMenuOptionProfile' },
    { text: 'Preferred Lanes', fn: onGoToPreferredLanes, testID: 'avatarMenuOptionPreferredLane' },
    { text: 'Logout', fn: onLogout, testID: 'avatarMenuOptionLogout' }
  ]
  return (
    <Menu
      items={menuItems}
      style={{
        alignItems: 'center'
      }}
    >
      <View style={styles.avatarContainer} testID='avatarMenu' accessibilityLabel='avatarMenu'>
        <Image
          name='defaultAvatar'
          src={avatar ? getAvatarImage(avatar) : null}
          mode='cover'
        />
      </View>
    </Menu>
  )
}

const useStyles = (isTablet) => StyleSheet.create({
  avatarContainer: {
    height: isTablet ? 60 : 40,
    width: isTablet ? 60 : 40,
    borderRadius: 50,
    overflow: 'hidden',
    marginLeft: 3
  }
})

export default UserPhoto
